module.exports = __webpack_public_path__ + "static/media/8.ef7fde80.JPG";